import { pathOr } from 'ramda';

const defaultState = () => ({
});

export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    /**
     * Empty mutation is needed for proper work of Sagas.
     * We will add management of api request here in near future. (i.g. retries of failed request)
     */
    fetch() {},
  },
  actions: {
    refetchInvoicesByIds(_) {
    },
    refetchInvoices(_) {
    },
    getCompanyData({ commit, rootGetters }, { id, countryCode }) {
      return new Promise((resolve, reject) => {
        commit(
          'api/fetch',
          {
            url: '/services/company-lookups',
            method: 'POST',
            body: {
              country: countryCode,
              number: String(id).replace(/\s/g, ''),
            },
            headers: rootGetters['auth/getHeaders'],
            promise: {
              resolve,
              reject,
            },
          },
          { root: true },
        );
      });
    },
    apiGet({ commit }, url) {
      return new Promise((resolve, reject) => {
        commit(
          'api/fetch',
          {
            url,
            method: 'GET',
            promise: {
              resolve,
              reject,
            },
          },
          { root: true },
        );
      });
    },
    apiPost({ commit }, { url, data }) {
      return new Promise((resolve, reject) => {
        commit(
          'api/fetch',
          {
            url,
            body: {
              ...data,
            },
            method: 'POST',
            promise: {
              resolve,
              reject,
            },
          },
          { root: true },
        );
      });
    },
    sendForgottenCode({ commit }, email) {
      return new Promise((resolve, reject) => {
        commit(
          'api/fetch',
          {
            url: '/forgotten-password',
            method: 'POST',
            promise: {
              resolve,
              reject,
            },
            onSuccess: ['api/sendForgottenCodeProcessResponse'],
            onError: [
              {
                type: 'flashMessages/addMessage',
                kind: 'error',
                key: 'generalApiError',
              },
            ],
            body: {
              email,
            },
          },
          { root: true },
        );
      });
    },
    sendForgottenCodeProcessResponse({ dispatch }, { payload }) {
      const isError = pathOr(false, ['data', 'error'], payload);
      if (isError) {
        dispatch(
          {
            type: 'flashMessages/addMessage',
            kind: 'error',
            key: 'sendForgottenCodeError',
            params: { email: payload.meta.body.email },
          },
          { root: true },
        );
      } else {
        dispatch(
          {
            type: 'flashMessages/addMessage',
            kind: 'success',
            key: 'sendForgottenCodeSuccess',
            params: { email: payload.meta.body.email },
          },
          { root: true },
        );
      }
    },
  },
};
